export const MAX_NUMBER_OF_IDS_IN_GET_QUERY = 100;

export const COMPARMENT_PATHWAYS_FETCHING_ERROR_PREFIX = 'Failed to fetch compartment pathways';
